import React from 'react';
import { AuthLayout, FormGroup, InputTextblock } from '../../components';
import { useLocation } from 'react-router-dom';

const Mitra = () => {

    const location = useLocation()
    const { users } = location.state;

    return (
        <AuthLayout title='Data Mitra'>
            <div className='py-5'>
                <div className="w-full flex justify-center lg:mt-8 mt-20">
                    <img className="w-80"
                        src="/assets/imgs/animate-search.gif" alt="" />
                </div>
                <FormGroup label={'ID Mitra'}>
                    <InputTextblock placeholder='ID Mitra' value={users.code} />
                </FormGroup>
                <FormGroup label={'Nama Lengkap'}>
                    <InputTextblock placeholder='Nama Lengkap' value={users.fullName} />
                </FormGroup>
                <FormGroup label={'Email'}>
                    <InputTextblock placeholder='Email' value={users.email} />
                </FormGroup>
            </div>
        </AuthLayout>
    );
};

export default Mitra;